export default __webpack_public_path__ + "static/media/unstaking-step-three-labs.0af181ba.svg";